/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: content-seasonvolume-editor-component.js
 *
 * Created by randysorensen on 8/12/2017.
 */

'use strict';

function ContentSeasonVolumeEditorController (_, $route, $location, $routeParams, BreadcrumbService, ContentEditService,
											  SidebarService) {

	var self = this;

	//========================//
	// PERMISSION VIEW STATES //
	//========================//

	self.seasonVolumeViewStates = {
		season: {
			preRoll: 'SERIES_SEASON_PREROLL_SEARCH_VIEW_STATE',
			postRoll: 'SERIES_SEASON_POSTROLL_SEARCH_VIEW_STATE'
		},
		volume: {
			preRoll: 'SERIES_VOLUME_PREROLL_SEARCH_VIEW_STATE',
			postRoll: 'SERIES_VOLUME_POSTROLL_SEARCH_VIEW_STATE'
		}
	};

	//=================//
	// Lifecycle Hooks //
	//=================//

	self.$onInit = function () {
		self.currentTab = $routeParams.editView;
		self.editService = ContentEditService;
		SidebarService.editService = ContentEditService;
		BreadcrumbService.editService = ContentEditService;

		self.searchEnabledTabs = ['collaborators'];

		// setup breadcrumbs
		self.breadcrumb = ContentEditService.seasonVolumeBreadcrumb;
		ContentEditService.resetBreadcrumbs();
		BreadcrumbService.addBreadcrumb(ContentEditService.contentBreadcrumb);
	};

	self.onTabSelect = function (tabName) {
		$route.updateParams({editView: tabName});
	};

	self.onTabDeselect = function (tabName, event) {
		if (self.editService.editorForm && self.editService.editorForm.$dirty) {
			event.preventDefault();
			ContentEditService.showUnsavedChangesNotification();
		}
	};

	//======//
	// MISC //
	//======//

	self.isSeason = function () {
		return $location.$$url.indexOf('seasons') > -1;
	};

    self.isSearchEnabled = function () {
        return _.includes(self.searchEnabledTabs, self.currentTab);
    };

    // TODO: Remove function?
    self.isNextPreviousShown = () => {
        return false;
    };

}

angular
	.module('prism-ui.content')
	.component('contentSeasonVolumeEditor', {
		controller: ContentSeasonVolumeEditorController,
		bindings: {
            content: '<',
            season: '<'
		},
		templateUrl: 'meta/content/editor/components/view/seasonvolume/editor/content-seasonvolume-editor-template.html'
	});
